import React from "react";
import { ITooltipStyling } from "./tooltip-options.interface";

export enum TooltipTypeEnum {
    Generic = 1,
    Bubble = 2
}

export interface ITooltipViewModel {
    readonly id: string;
    readonly tooltipType: TooltipTypeEnum;
    closeTooltip(): void;
    render(): string | React.ReactElement | null;
    readonly zIndex: number;
    readonly animated: boolean;
    readonly hasGlow: boolean;
    readonly shouldShowCloseButton: boolean;
    readonly invertCloseButtonColors: boolean;
    readonly styling: ITooltipStyling | undefined;
    shouldDisplay(): boolean;
    onToolTipRendered(tooltipContainer: HTMLElement): void;
    readonly hasOwnStyle?: boolean;
}